module.exports = __webpack_public_path__ + "static/media/coin.fafc1441.mp3";